import { CategoryModalView } from '../../../javascripts/category_modal_mobile';
import PostCardSnsUserMuteComponent, { muteByUserId, unmuteByUserId } from '../../../../components/mutes/post_card_sns_user_mute_component';

document.addEventListener('DOMContentLoaded', () => {
  const categorySearch = document.querySelector("#announcement-category-search");
  const statusSearch = document.querySelector("#announcement-status-search");

  if (categorySearch) new CategoryModalView(categorySearch);
  if (statusSearch) new CategoryModalView(statusSearch);

  new PostCardSnsUserMuteComponent();
  addMuteUserEvent(document);
  addUnmuteUserEvent(document);
  initializeToggleMuteComponentMutationObserver();
});

// ユーザーをミュートした場合、ユーザーが投稿した他の投稿もミュートするイベントを登録する
function addMuteUserEvent(node) {
  node.querySelectorAll('.js-mute-btn[data-type="User"]').forEach((muteUserBtn) => {
    muteUserBtn.addEventListener('click', () => {
      $.modal.close();
      const userId = muteUserBtn.dataset.id;
      muteByUserId(userId);
    });
  });
}

// ユーザーをミュートを解除した場合、ユーザーが投稿した他の投稿もミュート解除するイベントを登録する
function addUnmuteUserEvent(node) {
  node.querySelectorAll('.js-unmute-btn[data-type="User"]').forEach((unmuteUserBtn) => {
    unmuteUserBtn.addEventListener('click', () => {
      $.modal.close();
      const userId = unmuteUserBtn.dataset.id;
      unmuteByUserId(userId);
    });
  });
}

function initializeToggleMuteComponentMutationObserver() {
  const mutationObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      Array.from(mutation.addedNodes)
        .filter(node => node.nodeType === Node.ELEMENT_NODE)
        .forEach(node => {
          addMuteUserEvent(node);
          addUnmuteUserEvent(node);
        });
    });
  });
  const observeTarget = document.body;
  mutationObserver.observe(observeTarget, { childList: true });
}
